"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _typeof2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _SuperPopup = _interopRequireDefault(require("@/views/marketingCampaign/components/SuperPopup.vue"));
var _SuperDetails = _interopRequireDefault(require("@/views/marketingCampaign/components/SuperDetails.vue"));
var _marketingCampaign = require("@/api/marketingCampaign");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SuperRedRank',
  components: {
    SuperPopup: _SuperPopup.default,
    SuperActivityDetails: _SuperDetails.default
  },
  data: function data() {
    return {
      value1: '',
      typeList: {
        'TB': '淘宝',
        'JD': '京东'
      },
      queryData: {
        title: '',
        rankSwitch: null,
        actionType: 'red',
        rankStartTime: null,
        rankEndTime: null,
        page: 1,
        size: 10,
        status: ''
      },
      total: 0,
      tableData: [],
      checkList: ['活动名称', '渠道类型', '报名人数', '累计发放红包数', '实际奖励总金额', '活动开始时间', '活动结束时间', '结算状态', '结算时间', '数据更新时间']
      // checkList: ['活动名称', '头图', '渠道类型', '报名开始时间', '报名结束时间', '报名人数', '累计发放红包数', '实际奖励总金额', '活动状态', '活动开始时间', '活动结束时间', '结算状态', '结算时间', '创建时间', '数据更新时间']
    };
  },
  created: function created() {
    this.listRank();
  },
  methods: {
    copyLink: function copyLink(val) {
      var _this = this;
      (0, _marketingCampaign.getRankPageLink)({
        rankId: val.rankId
      }).then(function (res) {
        if (res.data) {
          _this.$copyText(res.data).then(function () {
            _this.$notify.success({
              title: '温馨提示',
              message: '复制成功'
            });
          });
        }
      });
    },
    listRank: function () {
      var _listRank = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                title: this.queryData.title,
                rankSwitch: this.queryData.rankSwitch,
                actionType: this.queryData.actionType,
                unionCode: this.queryData.status,
                rankStartTime: null,
                rankEndTime: null,
                page: this.queryData.page,
                size: this.queryData.size
              };
              if (this.value1 != null && this.value1.length > 0) {
                params.rankStartTime = this.value1[0];
                params.rankEndTime = this.value1[1];
              }
              console.log((0, _typeof2.default)(params.rankStartTime));
              _context.n = 1;
              return (0, _marketingCampaign.listRankApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0 && res.data !== null) {
                this.total = res.data.total;
                this.tableData = res.data.data;
              } else {
                this.total = 0;
                this.tableData = [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listRank() {
        return _listRank.apply(this, arguments);
      }
      return listRank;
    }(),
    deleteRank: function deleteRank(row) {
      var _this2 = this;
      this.$confirm('确认是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        try {
          (0, _marketingCampaign.deleteRankApi)({
            rankId: row.rankId
          }).then(function (res) {
            if (res.code === 0) {
              _this2.$message({
                message: '删除成功',
                type: 'success'
              });
              _this2.listRank();
            }
          });
        } catch (err) {
          console.log(err);
        }
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    checkOut: function checkOut(row) {
      var _this3 = this;
      this.$confirm('确认是否要结算？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        try {
          (0, _marketingCampaign.settleRank)({
            rankId: row.rankId
          }).then(function (res) {
            if (res.code === 0) {
              _this3.$message({
                message: '结算成功',
                type: 'success'
              });
              _this3.listRank();
            }
          });
        } catch (err) {
          console.log(err);
        }
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    onEdit: function onEdit(row) {
      this.$refs.superPopup.openDialog({
        id: row.rankId,
        type: 'edit',
        rankStatus: row.rankStatus,
        indexType: row.indexType
      });
    },
    onCheckBox: function onCheckBox() {
      // localStorage.setItem('superRedRank', JSON.stringify(this.checkList))
    },
    onInquireList: function onInquireList() {
      this.queryData.page = 1;
      this.listRank();
    },
    onInitializeList: function onInitializeList() {
      this.queryData.title = '';
      this.queryData.rankSwitch = '';
      this.queryData.status = '';
      this.value1 = '';
      this.queryData.page = 1;
      this.listRank();
    },
    onRecharge: function onRecharge() {
      this.$refs.superPopup.openDialog({
        type: 'add'
      });
    },
    onDetails: function onDetails(row) {
      this.$refs.superActivityDetails.openDialog({
        rankId: row.rankId,
        indexType: row.indexType
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listRank();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listRank();
    }
  }
};